module.exports = __webpack_public_path__ + "img/Logo.a97ba454.png";